<template lang="pug">
span
  span(@click="modal_open")
    slot(name="activator")

  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="520")
    v-card
      title-bar(dark) {{ title }}
      v-card-text
        v-select(:items="teamMembers" v-model="selectedAssignedUser" label="Assign to" placeholder="Select a Team Member")
          template(slot="item" slot-scope="data")
            v-list-tile
              v-list-tile-content
                v-list-tile-title(v-text="data.item.text")
                v-list-tile-sub-title(v-text="data.item.description")

      v-card-actions
        v-spacer
        v-btn(flat @click="modal_close") Cancel
        v-btn.primary(@click="save" :disabled="!canSave") Save

</template>

<script>
import Modal from '@/Core/mixins/modal';
import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  props: {
    contactUpdateActionPayload: {
      type: Function,
    },
    patchContacts: {
      type: Function,
    },
    teamMembers: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
    selectedIdsWithAssigneeId: {
      type: Array,
      required: true,
    },
    isContactProfile: {
      type: Boolean,
      default: false,
    },
    currentContact: {
      type: Array,
      default: () => [],
    },
    totalContactsSelected: {
      type: Number,
    },
  },
  computed: {
    selectedContacts() {
      return this.isContactProfile ?
        this.currentContact :
        this.selectedIdsWithAssigneeId;
    },
    title() {
      if (this.selectedIds.length === 1) {
        return 'Assign Contact to a Team Member';
      }
      return `Assign ${this.totalContactsSelected} Contacts to a Team Member`;
    },
    canSave() {
      return this.selectedAssignedUser !== null;
    },
  },
  data() {
    return {
      selectedAssignedUser: null,
    };
  },
  methods: {
    async save() {
      const action = this.contactUpdateActionPayload({
        assigned_user_id: this.selectedAssignedUser,
        is_bulk: true,
      });
      const payload = {
        action,
        selected: this.selectedIds,
      };
      this.modal_close();
      await this.patchContacts(payload);
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.selectedAssignedUser = null;
    },
  },
};
</script>
